export const Z_INDEX = {
  onboarding: 1400,
  bubble: 1250,
  bubbleOnboarding: 1500,
  absoluteElement: 100,
};
